<template>
  <div class="venue-profile">
    <div class="icon icon-grid" />
    {{ bookFor.fullname }}
  </div>
</template>

<script>
'use strict'
import { mapState } from 'vuex'

export default {
  name: 'VenueProfile',
  data: function() {
    return {
      venueName: false
    }
  },
  computed: {
    ...mapState('account', ['bookFor'])
  }
}
</script>

<style lang="scss" scoped>
.venue-profile {
  display: none;
  margin-right: 50px;
  @include sm() {
    display: flex;
  }

  .icon {
    display: flex;
    align-items: center;
    margin-right: 19px;
  }
}
</style>
